// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable unicorn/no-array-method-this-argument */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable eslint-comments/no-duplicate-disable */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable guard-for-in */

import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';

// class names
const CLASS_WRAPPER = 'p-activator-portal-homepage';
const CLASS_YOUR_ACTIONS = 'js-coach-notification-banner';
const CLASS_ACTIONS_BLOCK = 'p-activator-portal-homepage__actions';
const CLASS_ACTIONS_CARD_LINK = 'lta-card-link';
const CLASS_SUCCESS = 'p-hoodie-ordering-journey-success';
const CLASS_SUCCESS_BUTTON = 'p-hoodie-ordering-journey-success--button';
const CLASS_STEP = 'p-hoodie-ordering-journey-step';
const CLASS_QUESTION = 'p-hoodie-ordering-journey-questions';
const CLASS_STEP_NEXT = 'p-hoodie-ordering-journey-step-next';
const CLASS_EXIT_BUTTON = 'js-exit-hoodie-ordering-journey';
const CLASS_EXIT_CONFIRM_MODAL = 'js-exit-hoodie-ordering-journey-confirm';
const CLASS_EXIT_CONFIRM_YES = 'js-exit-hoodie-ordering-journey-confirm-yes';
const CLASS_EXIT_CONFIRM_NO = 'js-exit-hoodie-ordering-journey-confirm-no';
const CLASS_ERROR_MODAL = 'js-hoodie-ordering-journey-error-container';

// selectors
const SELECTOR_WRAPPER = `.${CLASS_WRAPPER}`;
const SELECTOR_YOUR_ACTIONS = `.${CLASS_YOUR_ACTIONS}`;
const SELECTOR_ACTIONS_BLOCK = `.${CLASS_ACTIONS_BLOCK}`;
const SELECTOR_ACTIONS_CARD_LINK = `.${CLASS_ACTIONS_CARD_LINK}`;
const SELECTOR_MODAL = '#js-hoodie-ordering-journey-modal';
const SELECTOR_SUCCESS = `.${CLASS_SUCCESS}`;
const SELECTOR_SUCCESS_BUTTON = `.${CLASS_SUCCESS_BUTTON}`;
const SELECTOR_STEP = `.${CLASS_STEP}`;
const SELECTOR_QUESTION = `.${CLASS_QUESTION}`;
const SELECTOR_STEP_NEXT = `.${CLASS_STEP_NEXT}`;
const SELECTOR_EXIT_BUTTON = `.${CLASS_EXIT_BUTTON}`;
const SELECTOR_EXIT_CONFIRM_MODAL = `.${CLASS_EXIT_CONFIRM_MODAL}`;
const SELECTOR_EXIT_CONFIRM_YES = `.${CLASS_EXIT_CONFIRM_YES}`;
const SELECTOR_EXIT_CONFIRM_NO = `.${CLASS_EXIT_CONFIRM_NO}`;
const SELECTOR_ERROR_MODAL = `.${CLASS_ERROR_MODAL}`;

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';
const REFERENCE_VALUE_OBJECT = 'label';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

class ActivatorPortalHomePage {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.actionsBlock = SelectorEngine.findOne(SELECTOR_ACTIONS_BLOCK, this._wrapper);
		this.YourActionsCard = SelectorEngine.find(SELECTOR_YOUR_ACTIONS, this._wrapper);
		this.HoodieOrderingJourneyModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.HoodieOrderingJourneyStep = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.HoodieOrderingJourneyQuestion = SelectorEngine.findOne(SELECTOR_QUESTION, this.HoodieOrderingJourneyStep);
		this.HoodieOrderingJourneyStepNext = SelectorEngine.findOne(SELECTOR_STEP_NEXT, this.HoodieOrderingJourneyStep);

		this.HoodieOrderingJourneySuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.HoodieOrderingJourneySuccessButton = SelectorEngine.findOne(
			SELECTOR_SUCCESS_BUTTON,
			this.HoodieOrderingJourneySuccess
		);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.errorModalHtml = SelectorEngine.findOne(SELECTOR_ERROR_MODAL, this._wrapper);
		this.errorModal = new Modal(this.errorModalHtml, { backdrop: 'static' });
		this.errorText = SelectorEngine.findOne('.error-text', this.errorModalHtml);
		this.closeErrorModal = SelectorEngine.findOne('.js-dismiss-error', this.errorModalHtml);

		this.formSteps = Manipulator.getDataAttribute(this.actionsBlock, 'form-steps-api');
		this.submitSteps = Manipulator.getDataAttribute(this.actionsBlock, 'submit-steps-api');

		this.HoodieOrderingJourneyModal = new Modal(this.HoodieOrderingJourneyModalElement, {
			backdrop: 'static'
		});
		this.HoodieOrderingJourneyModal.isEscapeEventEnable = false;

		for (const card of this.YourActionsCard) {
			EventHandler.on(card, CLICK_EVENT, (event_) => {
				const link = event_.target.closest(SELECTOR_ACTIONS_CARD_LINK);
				if (!link || !card.contains(link)) return;
				event_.preventDefault();
				const cardId = Manipulator.getDataAttribute(card, 'id');
				if (cardId == 'actionHoodie') {
					this.fetchHoodieOrderingSteps();
				}
			});
		}

		EventHandler.on(this.HoodieOrderingJourneySuccessButton, CLICK_EVENT, () => {
			window.location.reload();
		});

		if (this.closeErrorModal) {
			EventHandler.on(this.closeErrorModal, CLICK_EVENT, () => {
				this.errorModal.hide();
				window.location.reload();
			});
		}

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.exitButton, CLICK_EVENT, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, CLICK_EVENT, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, CLICK_EVENT, () => {
			this.exitConfirmModal.hide();
		});
	}

	showSuccessPage() {
		this.HoodieOrderingJourneyStep.classList.add(HIDDEN_CLASS);
		this.HoodieOrderingJourneySuccess.classList.remove(HIDDEN_CLASS);
	}

	showErrorContainer(error) {
		const message =
			(error && (error.message || error.errorMessage)) || (typeof error === 'string' && error) || 'An error occurred';
		if (this.errorText) {
			this.errorText.innerHTML = message;
		}
		if (this.errorModal) {
			this.errorModal.show();
		}

		// Ensure the form step remains visible if modal is shown
		if (this.HoodieOrderingJourneyStep) {
			this.HoodieOrderingJourneyStep.classList.remove(HIDDEN_CLASS);
		}
	}

	initiateFormGenerator(stepsData) {
		this.HoodieOrderingJourneyModal.show();
		this.HoodieOrderingJourneyStep.classList.remove(HIDDEN_CLASS);

		this.formGenerator = new FormGenerator(this.HoodieOrderingJourneyQuestion, {
			questions: stepsData,
			totalSteps: stepsData?.length || 1,
			hasSeparator: true,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			submitButton: {
				title: 'Submit'
			},
			radioAnswerField: 'id',
			isExitButtonEnabled: true,
			saveAddress: false,
			isBackButtonEnabled: true,
			exitButtonLabel: 'Close',
			exitButtonHandler: () => {
				this.exitConfirmModal.show();
			},
			backButtonHandlerFirstStep: () => {
				window.location.reload();
			}
		});

		this.formGenerator.onChange((answers) => {
			this.HoodieOrderingJourneyStep.classList.add(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
			this.saveHoodieOrderingSteps(this.answerList);
		});

		if (this.exitButton) {
			this.exitButton.classList.add(HIDDEN_CLASS);
		}
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				if (answerObject[KEY_OBJECT] === 'reference') {
					formatObject[answerObject[KEY_OBJECT]] = answerObject.isOthers
						? answerObject.value
						: answerObject[REFERENCE_VALUE_OBJECT].trim();
				}
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async fetchHoodieOrderingSteps() {
		startLoadingAnimation();
		try {
			if (!this.formSteps) {
				this.showErrorContainer('Form configuration missing (form-steps-api).');
				return;
			}
			const url = this.formSteps;
			const response = await Request.get(url, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			// handle the 'response with error' case
			if (!response) {
				this.showErrorContainer('No response from server.');
				return;
			}

			const { Steps, error } = response;

			// If back-end returns error object in the response
			if (error?.hasError) {
				const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
				this.showErrorContainer(errorMessage);
				return;
			}

			if (Steps && Steps.length > 0) {
				this.stepsData = Steps;
			}
		} catch (error) {
			const errorMessage =
				(error && (error.message || error.errorMessage)) || String(error) || 'An unexpected error occurred';
			this.showErrorContainer(errorMessage);
		} finally {
			stopLoadingAnimation();
		}
	}

	async saveHoodieOrderingSteps(requestObject) {
		startLoadingAnimation();
		try {
			if (!this.submitSteps) return;
			const url = this.submitSteps;
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();

			if (error?.hasError) {
				const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
				this.showErrorContainer(errorMessage);
				return;
			}

			if (Success || success) {
				this.showSuccessPage();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error && typeof error === 'object' && (error.hasError || error.statusCode >= 400)) {
				const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
				this.showErrorContainer(errorMessage);
			}
		}
	}

	handleModalExit() {
		window.location.reload();
	}
}

const globalActivatorPortalHomePage = new ActivatorPortalHomePage();
export default globalActivatorPortalHomePage;
